(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-compliance-cycle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.zap-cycle-section[data-zap-cycle]');
    sections.forEach(function (root) {
      var wrap = root.querySelector('.cycle-wrap');
      if (!wrap) return;
      var btn = wrap.querySelector('.cycle__toggle');
      if (!btn || btn.dataset.zapBound === 'true') return;
      btn.dataset.zapBound = 'true';
      btn.addEventListener('click', function () {
        var paused = wrap.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play the animation' : 'Pause the animation');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-compliance-heatmap"] && !Shopify.designMode) return;
  try {
    
  /* Heatmap generator, ported from the compliance site. Scoped per section instance
     via [data-zap-heatmap] roots and queried WITHIN each root, so multiple instances
     never collide (no global ids). Sample data, illustrative of remediation cadence. */
  (function () {
    function buildHeatmap(root) {
      if (root.hasAttribute('data-hm-built')) return;
      var cal = root.querySelector('[data-hm-cal]');
      if (!cal) return;
      root.setAttribute('data-hm-built', 'true');

      var levels = ['rgba(199,212,255,.08)', '#3b2d6b', '#5a3fb0', '#7c5ce0', '#a892f5'];
      var seed = 20260625;
      function rnd() { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; }
      var weeks = 53, total = 0, frag = document.createDocumentFragment();
      for (var wk = 0; wk < weeks; wk++) {
        var ramp = wk / weeks;
        for (var d = 0; d < 7; d++) {
          var weekday = d > 0 && d < 6, base = (weekday ? 0.45 : 0.12) + ramp * 0.5, v = rnd(), lvl = 0;
          if (v < base * 0.35) lvl = 4; else if (v < base * 0.7) lvl = 3; else if (v < base * 1.05) lvl = 2; else if (v < base * 1.5) lvl = 1;
          var c = document.createElement('i'); c.style.background = levels[lvl];
          if (lvl > 0) { var n = lvl * 4 + Math.floor(rnd() * 5); total += n; c.title = n + ' barriers fixed'; }
          frag.appendChild(c);
        }
      }
      cal.appendChild(frag);
      var totalEl = root.querySelector('[data-hm-total]');
      if (totalEl) totalEl.textContent = total.toLocaleString('en-US');
      var months = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
      var mh = root.querySelector('[data-hm-months]');
      if (mh) {
        months.forEach(function (m) { var s = document.createElement('span'); s.textContent = m; mh.appendChild(s); });
      }
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('[data-zap-heatmap]');
      for (var i = 0; i < roots.length; i++) buildHeatmap(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor: rebuild when this section is (re)loaded. */
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
